function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\uF4DE");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Calendar---Events-Calendar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-Calendar---Filters",
  transform: "translate(-1096.000000, -585.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "7.-Small-Components/7.4-Labels-and-Pills/Pills/Filters/Unselected-Copy-10",
  transform: "translate(1085.000000, 578.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Small/Solid/Gray",
  transform: "translate(8.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Calendar/12px/Dark",
  transform: "translate(-2.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.3749705,15.500025 C18.8257574,15.500025 19.9999642,14.3257896 19.9999642,12.8750027 L19.9999642,3.50002503 L13.9999807,3.50002503 C13.5851312,3.50002503 13.2499803,3.83517591 13.2499803,4.25002325 L13.2499803,11.834371 L5.13829008,14.0468749 C5.03749076,14.0750044 4.97889715,14.1781154 5.00702666,14.2765573 L5.30235218,15.3617063 C5.33045881,15.4625057 5.43359272,15.5210993 5.53203456,15.4929698 L14.7593609,12.9757791 C14.815597,14.3773337 15.9593397,15.500025 17.3749705,15.500025 Z M6.63592902,12.5679813 L11.7078011,11.2086096 C11.9070194,11.1546851 12.0265412,10.9484402 11.9726396,10.7492219 L10.8077941,6.40157604 C10.7538925,6.20235776 10.5476476,6.08283595 10.3484293,6.1367375 L8.53905406,6.62423176 L9.1202981,8.79688741 L7.67186863,9.18360523 L7.09062459,7.01094959 L5.27891474,7.49610926 C5.07969647,7.5500108 4.96015177,7.75625573 5.01405331,7.95547401 L6.17656427,12.3031199 C6.23046582,12.5023382 6.43671075,12.6218829 6.63592902,12.5679813 Z M17.3749705,14 C16.7538782,14 16.2499732,13.496095 16.2499732,12.8750027 C16.2499732,12.2539104 16.7538782,11.7500054 17.3749705,11.7500054 C17.9960628,11.7500054 18.4999678,12.2539104 18.4999678,12.8750027 C18.4999678,13.496095 17.9960628,14 17.3749705,14 Z",
  id: "\\uF4DE"
}))))));

var SvgReturnIconFiltersSelected = function SvgReturnIconFiltersSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReturnIconFiltersSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ReturnIconFiltersSelected.e3598e2d.svg";
export { ForwardRef as ReactComponent };